import { Colors } from "src/styles/DesignSystem";
import styled from "styled-components";

export const TextContainer = styled.article`
    width: 65%;
    margin: 2.5% auto;

    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 80%;
        margin: 0 auto;
    }
`;

export const TextP = styled.p`
    width: 65%;
    font: 1rem / 1.2 "Varela Round",arial,sans-serif;
    color: ${Colors.grey};

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 100%;
        margin-bottom: 5%;
    }
`;